import React from "react";
import "./styles.scss";
import { useSelector } from "react-redux";
import DSOButton from "../../UI/button/DSOButton";

const Index = ({ option, onClickEditAddress, address, onClickDeleteAddress, isEditButtonShow, isDeleteButtonShow }) => {
  const { provinceList } = useSelector(({ landingPageReducer }) => landingPageReducer);

  const title = (address) => {
    switch (address.AddressType) {
      case 1:
        return "Permanent address";
      case 2:
        return "Correspondence address";
      case 4:
        return "Employer address";
      default:
        return "";
    }
  };

  const renderAddress = () => {
    let addressText = "";
    if (address.Line1) {
      addressText = addressText.concat(`${address.Line1}, `);
    }
    if (address.Line2) {
      addressText = addressText.concat(`${address.Line2}, `);
    }
    if (address.Line3) {
      addressText = addressText.concat(`${address.Line3}, `);
    }
    if (address.City) {
      addressText = addressText.concat(`${address.City}, `);
    }
    if (address.State) {
      const state = provinceList.find((province) => province.ValueText === address.State);
      addressText = addressText.concat(`${state?.DisplayText ?? ""}, `);
    }
    if (address.Country) {
      addressText = addressText.concat(`${address.Country}. `);
    }
    return addressText;
  };

  return (
    <div className={`address-card-wrapper animate__animated animate__fadeIn ${option}`}>
      <div className={"address-card-title"}>{title(address)}</div>
      <div className={"address-body"}>{renderAddress()}</div>
      <div className={"address-footer-wrapper d-flex "}>
        {isEditButtonShow && (
          <DSOButton
            text="Edit"
            btnType="next"
            className="full-width address-card-btn edit-btn"
            onClick={() => {
              onClickEditAddress && onClickEditAddress();
            }}
          />
        )}
        {isDeleteButtonShow && (
          <DSOButton
            text="Delete"
            btnType="remove"
            className="full-width address-card-btn delete-btn"
            onClick={() => {
              onClickDeleteAddress && onClickDeleteAddress();
            }}
          />
        )}
      </div>
    </div>
  );
};
export default Index;
